import { Navigate } from 'react-router-dom'
import { PageLoader } from '@/components/ui/PageLoader'
import { CLINICIAN_NAV_ITEMS } from '@/components/layout/clinician-nav-items'
import { ROUTES } from '@/constants'
import { usePermissions } from '@/services/permissions'

/**
 * Where "/app" lands: the first menu item the signed-in role may open, in menu order. So a role
 * without the dashboard permission starts on Patients, Appointments or wherever its access
 * begins, instead of on an access-denied page.
 */
export default function LandingRedirect() {
  const { canAny, isLoading } = usePermissions()
  if (isLoading) return <PageLoader />
  const first = CLINICIAN_NAV_ITEMS.find(
    (item) =>
      !item.permission ||
      canAny(...(Array.isArray(item.permission) ? item.permission : [item.permission])),
  )
  return <Navigate to={first?.to ?? ROUTES.APP.PROFILE} replace />
}
